export default function isGlob() {
  // the website config is static and doesn't use glob config
  return false;
}
